"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinDepositRuleSchema = exports.createFinDepositRuleSchema = exports.finDepositRuleScopeTypeEnum = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (IP Billing Administration, Module 4 — Deposit Rules). */
exports.finDepositRuleScopeTypeEnum = zod_1.z.enum(['GLOBAL', 'WARD_TYPE', 'ADMISSION_TYPE', 'PAYER_TYPE']);
const finDepositRuleBaseShape = {
    name: zod_1.z.string().min(1).max(255),
    scopeType: exports.finDepositRuleScopeTypeEnum,
    scopeId: zod_1.z.string().uuid().optional(),
    minimumDepositAmount: zod_1.z.number().int().positive().optional(),
    minimumDepositPercent: zod_1.z.number().min(0).max(100).optional(),
    topUpThresholdPercent: zod_1.z.number().min(0).max(100).optional(),
    isMandatory: zod_1.z.boolean().optional(),
};
exports.createFinDepositRuleSchema = zod_1.z
    .object(finDepositRuleBaseShape)
    .refine((data) => data.scopeType === 'GLOBAL' || Boolean(data.scopeId), {
    message: 'scopeId is required unless scopeType is GLOBAL',
    path: ['scopeId'],
})
    .refine((data) => data.minimumDepositAmount !== undefined || data.minimumDepositPercent !== undefined, {
    message: 'either minimumDepositAmount or minimumDepositPercent is required',
    path: ['minimumDepositAmount'],
});
exports.updateFinDepositRuleSchema = zod_1.z.object(finDepositRuleBaseShape).partial();
//# sourceMappingURL=fin-deposit-rule.schema.js.map